/**
 * API de usuarios usando Axios.
 */
import { axiosInstance } from "features/shared/api";
import { config } from "common/config";
import type { CreateUserRequest, UpdateUserRequest, UserDto } from "common/models";

export interface CityDto {
    code: number;
    name: string;
    department: { code: number; name: string };
}

export const usersApi = {
    create: (body: CreateUserRequest) =>
        axiosInstance.post<UserDto>("/api/users", body),

    info: (organizationAddress: string) =>
        axiosInstance.get<UserDto>("/api/users/info", {
            headers: { "authorization-resource": organizationAddress },
        }),

    updateUser: (body: UpdateUserRequest) =>
        axiosInstance.put("/api/users", body),

    getCities: () =>
        axiosInstance.get<CityDto[]>(config.apiFindAllCities),

    validateInvitedUser: (
        identificationType: string,
        identificationCode: string,
        apiKeyOrq = "pecop.pideky_escala.near"
    ) =>
        axiosInstance.get<UserDto>("/api/users/validate-invited-user", {
            params: { identificationType, identificationCode, apiKeyOrq },
        }),

    validateMigratedUser: (identificationCode: string, apiKeyOrq?: string) =>
        axiosInstance
            .get<{ migrated: boolean }>("/api/users/validate-migrated-user", {
                params: { identificationCode, apiKeyOrq },
            })
            .then((r) => r.data),
};
